import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';

// Context
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LoadingSpinner from './components/LoadingSpinner';

// Pages
import Home from './pages/Home';
import Post from './pages/Post';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Search from './pages/Search';
import Category from './pages/Category';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminPosts from './pages/admin/AdminPosts';
import AdminNewPost from './pages/admin/AdminNewPost';
import AdminEditPost from './pages/admin/AdminEditPost';
import AdminComments from './pages/admin/AdminComments';
// import AdminAIAssistant from './pages/admin/AdminAIAssistant';

// Protected Route Component
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <HelmetProvider>
      <ThemeProvider>
        <AuthProvider>
          <Router>
            <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
              <Navbar />
              
              <main className="min-h-screen">
                <Routes>
                  {/* Public Routes */}
                  <Route path="/" element={<Home />} />
                  <Route path="/post/:slug" element={<Post />} />
                  <Route path="/category/:category" element={<Category />} />
                  <Route path="/search" element={<Search />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/terms" element={<Terms />} />
                  
                  {/* Admin Routes */}
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route 
                    path="/admin" 
                    element={
                      <ProtectedRoute>
                        <AdminDashboard />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/admin/posts" 
                    element={
                      <ProtectedRoute>
                        <AdminPosts />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/admin/new" 
                    element={
                      <ProtectedRoute>
                        <AdminNewPost />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/admin/edit/:id" 
                    element={
                      <ProtectedRoute>
                        <AdminEditPost />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/admin/comments" 
                    element={
                      <ProtectedRoute>
                        <AdminComments />
                      </ProtectedRoute>
                    } 
                  />
                  {/* <Route 
                    path="/admin/ai-assistant" 
                    element={
                      <ProtectedRoute>
                        <AdminAIAssistant />
                      </ProtectedRoute>
                    } 
                  /> */}
                  
                  {/* Redirect unknown routes to home */}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </main>
              
              <Footer />
              <Toaster 
                position="top-right"
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: '#363636',
                    color: '#fff',
                  },
                }}
              />
            </div>
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
